export default __webpack_public_path__ + "static/media/kanipakamPlacesThree.723edd94.png";